import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    borderBottom: "1px solid #d5d2d5",
    backgroundColor: "#f6f6f7"
  },

  titleText: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#4b1c46"
  },

  dialogContent: {
    padding: "16px",
    // MUI zeroes padding-top on a DialogContent that follows a DialogTitle
    // (`.MuiDialogTitle-root + .MuiDialogContent-root`); that rule outranks a
    // single class, so restore it at matching specificity.
    "&.MuiDialogContent-root": {
      paddingTop: "16px"
    }
  },

  description: {
    fontSize: "13px",
    color: "#736973",
    marginBottom: "18px"
  },

  field: {
    marginBottom: "16px"
  },

  chipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    marginTop: "-8px",
    marginBottom: "16px"
  },

  chip: {
    maxWidth: "100%"
  },

  checkboxLabel: {
    alignItems: "flex-start",
    marginLeft: "-9px",
    "& .MuiFormControlLabel-label": {
      paddingTop: "8px"
    }
  },

  checkboxTitle: {
    fontSize: "14px",
    color: "#333"
  },

  checkboxHint: {
    fontSize: "12px",
    color: "#8f8a8f"
  },

  error: {
    marginTop: "12px",
    fontSize: "13px"
  },

  dialogActions: {
    padding: "10px 16px",
    borderTop: "1px solid #e5e2e5"
  }
}));

export default useStyles;
